// Discover dialog store — глобальный «Найти в интернете» из Add menu.
// Не персистится: при перезагрузке всегда закрыт.
import { create } from "zustand";

interface DiscoverDialogStore {
	isOpen: boolean;
	open: () => void;
	close: () => void;
	setOpen: (open: boolean) => void;
}

export const useDiscoverDialogStore = create<DiscoverDialogStore>((set) => ({
	isOpen: false,
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
	setOpen: (open) => set({ isOpen: open }),
}));
